<template>
  <div class="flex space-x-4 flex-1">
    <div v-if="activeBlock" class="flex flex-col space-y-3 flex-1 max-w-100">
      <uiTextarea v-model="activeBlock.title" label="Заголовок блока" />

      <uiDropdown
        label="Тип блока"
        :options="blockKinds"
        :clearSearchOnSelect="true"
        :value="blockKinds.find(k => k.value === activeBlock.kind)"
        @input="selectKind"
      />

      <block-group
        :kind="activeBlock.kind"
        :block="activeBlock"
        mode="edit"
        :activeItem="activeItem"
        @add="addItem(activeBlock)"
        @click-item="setActiveBlockItem"
        @delete-item="deleteItem(activeBlock, $event)"
      />

      <uiButton
        v-if="activeBlock?.id.startsWith('new_')"
        class="ml-auto px-4"
        @click="createBlock(activeBlock)"
      >
        Создать
      </uiButton>

      <div v-else class="flex">
        <uiButton class="px-4" color="red" @click="deleteBlock(activeBlock)">
          Удалить блок
        </uiButton>

        <uiButton class="ml-auto px-4" @click="updateBlock(activeBlock)">
          Сохранить
        </uiButton>
      </div>
    </div>

    <div v-if="activeItem" class="flex flex-col space-y-3 flex-1 max-w-100">
      <router-view :key="activeItem.id" :activeItem="activeItem" />
    </div>
  </div>
</template>

<script>
import BlockGroup from '../components/BlockGroup.vue'
import { mapToList } from '@/utils/select'
import { onMounted, ref, computed } from 'vue'
import { useBlocks } from '../composables/blocks'
import { useRoute, useRouter } from 'vue-router/composables'

export default {
  components: {
    BlockGroup
  },
  setup () {
    const router = useRouter()
    const route = useRoute()

    const activeBlock = ref()
    const {
      blocks,
      blockKindMap,
      createBlock,
      updateBlock,
      deleteBlock,
      addItem,
      deleteItem
    } = useBlocks({
      router,
      route
    })
    const blockKinds = mapToList(blockKindMap)

    onMounted(() => {
      activeBlock.value = blocks.value.find(
        block => block.id === route.params.id
      )
    })

    function selectKind ({ value }) {
      activeBlock.value.kind = value
      const [firstItem] = activeBlock.value?.items ?? []

      if (!firstItem || value !== 'single-card') return

      if (
        route.name === 'articles-block-subitem' &&
        route.params.itemId !== firstItem.id
      ) {
        router.push({
          name: 'articles-block-subitem',
          params: {
            itemId: firstItem.id
          }
        })
      }
    }

    function setActiveBlockItem (item) {
      if (route.params.itemId === item.id) return

      router.push({
        name: 'articles-block-subitem',
        params: {
          itemId: item.id
        }
      })
    }

    const activeItem = computed(() => {
      const itemId = route.params.itemId
      return activeBlock.value?.items?.find(item => item.id === itemId)
    })

    return {
      blockKinds,
      createBlock,
      updateBlock,
      deleteBlock,
      activeBlock,

      selectKind,
      addItem,
      setActiveBlockItem,
      deleteItem,

      activeItem
    }
  }
}
</script>
